import { create } from "zustand";
import { _single } from "../../../core/services/dataBean/EntityCatalog";

interface DashboardStore {
    activeNav: number,
    loading: boolean,
    setLoading: (v: boolean) => void
}

export const useDashboardStore = create<DashboardStore>((set, get) => (
    {
        activeNav: 0,
        loading: false,
        setLoading: (loading) => {
            set({ loading })
            _single.spinner(loading);
        }
    }
))